<template>
  <div class="videos">
    <nav-headers />
    <div class="contents">
      <div class="in-banner">
        <div class="p-nav">
          <div class="p-title">
            <div class="p-1">VIDEO</div>
            <div class="p-2">Home / VIDEO</div>
          </div>
        </div>
        <img src="../assets/img/ny-06-VIDEO.jpg" width="100%" height="auto" />
      </div>
      <div class="pageBox waps ">
        <div class="products-nav-centers">
          <div class="products-leixing">
            <span style="margin-right: 10px;" :class="{ 'active': newType == '' }" @click="changeNew('')">ALL
            </span>
            /
            <span style="margin-right: 10px;margin-left: 10px" :class="{ 'active': newType == 17 }" @click="changeNew(17)">
              Company Video
            </span>
            /
            <span style="margin-left: 10px;" :class="{ 'active': newType == 18 }" @click="changeNew(18)">
              Product Video
            </span>
          </div>
        </div>
        <div class="products-centers">
          <div class="items" v-for="(val, index) in product" :key="index" @click="buy(val)"  :class="{'itemsLeft':parseInt((index+1))%2!=0}">
            <div class="bo">
              <div class="palyer"></div>
              <img src="../assets/img/cs_3.png"></img>
            </div>
            <div class="title">{{ val.title }}</div>
          </div>
        </div>
        <div class="el-pages">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="current_page"
            :page-size="pageSize" layout="prev,pager,next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <nav-footer />

    <el-dialog title="Video" :visible.sync="dialogVisible" :width="width" :before-close="handleClose">
      <video-player class="video-player-box" ref="videoPlayer" :playsinline="true" :options="playerOptions">
      </video-player>
    </el-dialog>

  </div>
</template>
<script>
//import NavHeaders from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: 'product',
  data() {
    return {
      newType: '',
      dialogVisible: false,
      baseUrl:'http://yingcheng.0576hs.com',
      width: '50%',
      playerOptions: {
        controls: true,
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: 'http://yingcheng.0576hs.com/uploads/media.mp4' // url地址
        }],
        poster: 'http://yingcheng.0576hs.com/uploads/cs_3.png', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },

      id: this.$route.params.id,
      Factorys: [],
      current_page:1,
      currentPage: 1, // 当前页码
      pageSize: 8, // 每页显示的行数
      total: 0,

      showSlide: '', //控制动画效果
      list: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      product: [

      ], //商品信息
      // 轮播图插件
      swiperOption: {
        autoplay: true,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  },
  components: {
    NavHeaders: () => import('@/components/NavHeaders.vue'),
    NavFooter,
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        console.log('Route changed from', from.path, 'to', to);
          let self = this
          this.newType =to.params.id
          self.id = self.newType
          self.getProductList()
      },
      deep: true
    }
  },
  mounted() {
    this.getProductList();
    this.$nextTick(() => {
      this.handleAnimate()//初始化第一次加载时在视口内就执行动画
      addEventListener('scroll', this.handleAnimate);
    })
  },

  destroyed() {
    removeEventListener('scroll', this.handleAnimate);
  },
  created() {
    document.documentElement.scrollTop = "0px";
    if(this.$route.params.id!='1'){
      this.newType=this.$route.params.id
    }
    setTimeout(this.handleAnimate, 1000);
    let viewportWidth = document.documentElement.clientWidth
    let self = this
    if (viewportWidth < 440) {
      self.width = '90%'
    }
  },
  methods: {
    handleClose() {
      this.$refs.videoPlayer.player.pause();
      this.dialogVisible = false
    },
    changeNew(val) {
      let self = this
      self.newType = val
      self.id = val
      self.getProductList()
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0;
        }
      })
    },
    handleCurrentChange(e) {
      let id = '14';
      this.currentPage = 1
      this.$api.mall.getVideos({ type: this.newType, limit: 9, page: e }).then((res) => {
        this.product = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 获取商品信息
    getProductList() {
      let id = '14';
      this.currentPage = 1
      this.$api.mall.getVideos({ type: this.newType, limit: 9, page: 1 }).then((res) => {
        this.product = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 购买
    buy(val) {
      this.dialogVisible = true
      //val = this.product[0]
      this.playerOptions.sources[0].src = this.baseUrl+val.file
      this.playerOptions.poster = this.baseUrl+val.image
      //let id = this.$route.params.id;
      // this.$router.push(`/newdetail/${val}`);
    },
    // 打开视频
    openVideo() {
      this.showSlide = 'slideDown';
    },
    // 关闭视频
    closeVideo() {
      this.showSlide = 'slideUp';
      setTimeout(() => {
        this.showSlide = '';
      }, 600);
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 0px) and (max-width:1024px) {
  .videos {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin:50px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 358px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
          text-transform: uppercase;
        overflow: hidden;
        margin: 25px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 90%;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;

        .itemsLeft{
          margin-left: 0px !important;
        }

        .items {
          width: 48%;
          margin-left: 4%;
          float: left;
          overflow: hidden;
          cursor: pointer;
          padding-bottom: 20px;
          box-sizing: border-box;

          .title {
            color: #fff;
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 8px;
            padding-right: 50px;
            background: #fff;
            font-size: 14px;
            box-sizing: border-box;

            color: #252525;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .bo {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            box-sizing: border-box;
            position: relative;

            .palyer {
              width: 100%;
              background: url(../assets/img/player.png) no-repeat center;
              background-size: 48px;
              position: absolute;
              top: 140px;
              height: 48px;
              margin: 0px auto;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
      img{
        width: 150%;
        height: auto;
      }

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 100%;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;  
          text-transform: uppercase;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 0px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 61px;

    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  .videos {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 358px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        text-transform: uppercase;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 1200px;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        column-count: 3;
        column-gap: 35px;

        .items {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          padding-bottom: 50px;
          margin: 0px auto;
          box-sizing: border-box;

          .title {
            color: #fff;
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 25px;
            padding-left: 50px;
            padding-right: 50px;
            background: #fff;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;

            color: #252525;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .bo {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            height: 328px;
            box-sizing: border-box;
            position: relative;

            .palyer {
              width: 100%;
              background: url(../assets/img/player.png) no-repeat center;
              background-size: 48px;
              position: absolute;
              top: 140px;
              height: 48px;
              margin: 0px auto;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;  
          text-transform: uppercase;

          padding: 0px;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;

    }
  }


}

@media screen and (min-width: 1601px) and (max-width:8000px) {
  .videos {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }

      .products-leixing {
        width: 358px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        text-transform: uppercase;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 1600px;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        column-count: 3;
        column-gap: 35px;

        .items {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          padding-bottom: 50px;
          margin: 0px auto;
          box-sizing: border-box;

          .title {
            color: #fff;
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 25px;
            padding-left: 50px;
            padding-right: 50px;
            background: #fff;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;

            color: #252525;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .bo {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            height: 328px;
            box-sizing: border-box;
            position: relative;

            .palyer {
              width: 100%;
              background: url(../assets/img/player.png) no-repeat center;
              background-size: 48px;
              position: absolute;
              top: 140px;
              height: 48px;
              margin: 0px auto;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;  
          text-transform: uppercase;

          padding: 0px;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;

    }
  }
}
</style>